import { render, staticRenderFns } from "./indexJiaoCheng.vue?vue&type=template&id=b517bbc4&scoped=true"
import script from "./indexJiaoCheng.vue?vue&type=script&lang=js"
export * from "./indexJiaoCheng.vue?vue&type=script&lang=js"
import style0 from "./indexJiaoCheng.vue?vue&type=style&index=0&id=b517bbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b517bbc4",
  null
  
)

export default component.exports